import React from "react";
import { T } from "../../../app/tokens.js";
import { contractualAreaMonth } from "../../../../shared/leaseAreaRent.js";
import { convertAmount } from "../../../utils/fxConvert.js";

export function AreaRentCurrentRates({ lease, displayCurrency, rates, asOf = new Date() }) {
  // This optional source view must not turn absent rate data into a coverage
  // defect on otherwise valid annual-anchor leases.
  if (!lease.areas?.some((area) => area.rentRates?.length)) return null;
  const month = contractualAreaMonth(lease.areas, asOf.getFullYear(), asOf.getMonth() + 1, lease.currency);
  const psf = (value) => {
    const converted = convertAmount(value, lease.currency, displayCurrency, rates);
    return converted == null ? "Unavailable" : `${displayCurrency} ${converted.toFixed(2)}/sf/yr`;
  };
  return <div data-testid="area-period-rates" style={{ marginTop: 10, paddingTop: 8,
    borderTop: `1px solid ${T.border}`, fontSize: T.fsXs, color: T.mid }}>
    <strong style={{ color: T.dark }}>Period-matched contractual rates · {month.from.slice(0, 7)}</strong>
    <div>Lease annualized rate: {psf(month.annualizedPsf)}
      {month.grossSf != null && ` · ${month.grossSf.toLocaleString()} contributing gross sf`}</div>
    {month.contributions.map((area) => <div key={area.areaId} style={{ marginTop: 5 }}>
      <div>{area.name}: {psf(area.annualizedPsf)}</div>
      <div>{area.sourceCitation} · {area.provenance}</div>
    </div>)}
    {!month.complete && <div>{month.issues.join("; ")}. Monthly rent and period rate unavailable.</div>}
    {month.complete && month.grossSf == null && <div>Recorded positive gross footage is required for every contributing area.</div>}
    <div style={{ marginTop: 4 }}>Monthly rate × 12, not the calendar-year anchor divided by current footage.</div>
    {lease.areas?.some((area) => area.rentRates?.length) && <details style={{ marginTop: 8 }}>
      <summary>Recorded area rate segments and source evidence</summary>
      {lease.areas.map((area) => <div key={area.id} style={{ marginTop: 6 }}>
        <strong>{area.name}</strong> · {area.sizeSf == null ? "Footage unknown" : `${Number(area.sizeSf).toLocaleString()} gross sf`}
        {" · "}{area.commencementDate || "Start unknown"}–{area.expirationDate || "End unknown"}
        {(area.rentRates || []).map((rate) => <div key={rate.id}>
          {rate.effectiveFrom}–{rate.effectiveTo}: {rate.annualRent == null ? "Rent unknown" : `${rate.currency || lease.currency} ${Number(rate.annualRent).toLocaleString()} annual`}
          {" · "}{rate.sourceCitation} · {rate.provenance}
        </div>)}
      </div>)}
    </details>}
  </div>;
}
